export default __webpack_public_path__ + "static/media/manVectorLoan.fd40a39b.svg";